<div class="grid ">
	<div class="col-12">
		<div class="card" *ngIf="!permissaoDetalhar">
			<div style="text-align: center;">
				<h4>Você não possui permissão de acesso essa página!</h4>
			</div>
		</div>
		<div class="card" *ngIf="permissaoDetalhar">
			<form >
				<div class="formgroup">
					<div class="flex justify-content-center" *ngIf="loading">
						<p-progressSpinner></p-progressSpinner>
					</div>
					<div *ngIf="messagemVisivel" class="field col-12 md:col-12">
						<p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
					</div>
					<div class="p-fluid p-formgrid grid pt-3 px-3" *ngIf="adiantamentoFolha && !loading">

						<div class="col-12 card-simple mb-5">
							<div class="p-fluid p-formgrid grid">
								<div class="col-12 md:col-3">
									<label class="label-superior">Profissional</label>
									<label class="label-inferior" id="profissional">{{ adiantamentoFolha.nomeProfissional }}</label>
								</div>
								<div class="col-12 md:col-2">
									<label class="label-superior">Valor</label>
									<label class="label-inferior" id="valor">{{ adiantamentoFolha.valor | currency:'BRL' }}</label>
								</div>
								<div class="col-12 md:col-2">
									<label class="label-superior">Forma de Pagamento</label>
									<label class="label-inferior" id="formaPagamento">{{ adiantamentoFolha.descricaoTipoPagamento }}</label>
								</div>
								<div class="col-12 md:col-2">
									<label class="label-superior">Data da Transação</label>
									<label class="label-inferior" id="data">{{ adiantamentoFolha.data | date:'dd/MM/yyyy' }}</label>
								</div>
								<div class="col-12 md:col-2">
									<label class="label-superior">Nº Parcelas</label>
									<label class="label-inferior" id="parcelas">{{ adiantamentoFolha.parcelas }}</label>
								</div>

							</div>
						</div>

						<div class="w-full mb-5">
							<div >
								<h5>Parcelas</h5>
							</div>
							<p-table #dt1 [value]="parcelasAdiantamentoFolha" dataKey="id" [rows]="10" [rowHover]="true"
								styleClass="p-datatable-gridlines" [paginator]="false" responsiveLayout="scroll"
								styleClass=" p-datatable-sm">
								<ng-template pTemplate="header" >
									<tr>
										<th>
											<div>
												Data Registro
											</div>
										</th>
										<th>
											<div>
												Descrição
											</div>
										</th>
										<th>
											<div>
												Identificação
											</div>
										</th>
										<th>
											<div>
												Data a Cobrar
											</div>
										</th>
										<th>
											<div>
												Valor Registro
											</div>
										</th>
										
									</tr>
								</ng-template>
								<ng-template pTemplate="body" let-item let-i="rowIndex">
									<tr>
										<td>
											<label>{{ item.dataRegistro | date:'dd/MM/yyyy' }}</label>
										</td>
										<td>
											<label>{{ item.descricao }}</label>
										</td>
										<td>
											<label>{{ item.descricao }}</label>
										</td>
										<td>
											<label>{{ item.dataCompetencia | date:'dd/MM/yyyy' }}</label>
										</td>
										<td>
											<label>{{ item.valorRegistro | currency:'BRL' }}</label>
										</td>
										
									</tr>
								</ng-template>
								<ng-template pTemplate="emptymessage">
									<tr>
										<td colspan="7">Nenhum registro cadastrado.</td>
									</tr>
								</ng-template>
							</p-table>
						</div>
					</div>

					<div class="p-fluid p-formgrid grid justify-content-end" *ngIf="!loading">
						<div class="field col-12 md:col-4 flex justify-content-end">
							<button type="button"  pButton icon="pi pi-arrow-left" label="Voltar"
								class="p-button-outlined md:w-9rem" routerLink="/apps/adiantamento"></button>
						</div>
					</div>

				</div>
			</form>
		</div>
	</div>
</div>